import { render } from "./MReward.vue?vue&type=template&id=f18d4110&scoped=true&ts=true"
import script from "./MReward.vue?vue&type=script&lang=ts"
export * from "./MReward.vue?vue&type=script&lang=ts"

import "./MReward.vue?vue&type=style&index=0&id=f18d4110&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18d4110"]])

export default __exports__